import { Injectable } from '@angular/core';
import { AbstractBookmarkService, BookmarkItem, SimpleBookmarkItem } from 'osn-shared';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MockBookmarkService extends AbstractBookmarkService {
  public readonly bookmarksChanged$: Observable<string[]> = of([]);

  public findBookmarkOfProgramByGuid(guid: string): BookmarkItem | undefined {
    return undefined;
  }

  public getBookmarkOfContent$(): Observable<SimpleBookmarkItem> {
    return of({
      title: { en: '', ar: '' },
      guid: '',
      contentLength: 0,
      bookmarkTime: 0,
      bookmarkPercent: 0,
      seasonNumber: undefined,
      episodeNumber: undefined,
      hasProgress: false,
      percentComplete: 0,
    });
  }
}
